import t from 'tcomb';

export const DemographicInfo = t.struct({
    age: t.String,
    gender: t.String,
    birthOrder: t.String,
    residence: t.String,
    schooltype: t.String,
    educationBoard: t.String,
    fatherEducation: t.String,
    fatherOccupation: t.String,
    motherEducation: t.String,
    motherOccupation: t.String,
    religion: t.String,
    familyStatus: t.String,
    professionReason: t.String

}, 'DemographicInfo');

export const getDefaultDemographicInfo =() => ({
    age: '',
    gender: '',
    birthOrder: '',
    residence: '',
    schooltype: '',
    educationBoard: '',
    fatherEducation: '',
    fatherOccupation: '',
    motherEducation: '',
    motherOccupation: '',
    religion: '',
    familyStatus: '',
    professionReason: ''
});


